module.exports = __webpack_public_path__ + "static/media/SC.fc8b1936.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SC.svg
// module id = 2254
// module chunks = 7